import { render, staticRenderFns } from "./BlogTwoColumn.vue?vue&type=template&id=707b581e&"
import script from "./BlogTwoColumn.vue?vue&type=script&lang=js&"
export * from "./BlogTwoColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports